import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Button from 'components/common/Button';
import ColorPicker from '../ColorPicker';
import { useDispatch } from 'react-redux';
import { addNotification } from 'actions/globalActions';

const LabelsTableRowForm = ({ label, priorities, onSubmitForm }) => {
  const dispatch = useDispatch();

  const [selectedName, setSelectedName] = useState(label.name);
  const [selectedColor, setSelectedColor] = useState(label.color);
  const [selectedPriority, setSelectedPriority] = useState(label.priority);
  const [oldPriority, setOldPriority] = useState(label.priority);

  const handleNameChange = (e) => {
    const { value } = e.target;
    setSelectedName(value);
  };

  const handleColorChange = (e) => {
    const { value } = e.target;
    setSelectedColor(value);
  };

  const handlePriorityChange = (e) => {
    const { value } = e.target;
    setSelectedPriority(value);
  };

  const validateColor = (color) => {
    const hexColorRegEx = /^#[a-fA-F0-9]{6}/;
    if (!hexColorRegEx.test(color)) {
      return {
        type: 'warning',
        title: 'Invalid label color',
        description: 'Use only hex colors',
      };
    }
    return null;
  };

  const validateName = (name) => {
    // only letters, numbers and whitespaces
    const nameRegEx = /^[A-Za-z0-9 ]+$/;
    if (!nameRegEx.test(name)) {
      return {
        type: 'warning',
        title: 'Invalid label name',
        description: 'Use only letters, numbers and spaces',
      };
    }
    return null;
  };

  const validatePriority = (number) => {
    const numRegEX = /^\d+$/;
    if (!numRegEX.test(number)) {
      return {
        type: 'warning',
        title: 'Invalid priority value',
        description: 'Use only numbers',
      };
    } else if (priorities.includes(parseInt(number)) && number !== oldPriority) {
      return {
        type: 'warning',
        title: 'Invalid priority value',
        description: 'Must be different from the other priority values',
      };
    }
    return null;
  };

  const submitForm = () => {
    const validationErrors = [
      validateColor(selectedColor),
      validateName(selectedName),
      validatePriority(selectedPriority),
    ].filter((e) => e !== null);
    if (validationErrors.length === 0) {
      onSubmitForm({
        name: selectedName,
        color: selectedColor,
        priority: parseInt(selectedPriority),
      });
      setOldPriority(selectedPriority);
    } else {
      dispatch(addNotification(validationErrors[0]));
    }
  };

  return (
    <div className="control">
      <div className="field">
        <label className="label">Name</label>
        <input
          className="input"
          name="name"
          type="text"
          value={selectedName}
          onChange={handleNameChange}
        />
        <p className="help">Only letters, numbers and whitespaces allowed</p>
      </div>

      <div className="field">
        <label className="label">Color</label>
        <div className="control has-icons-left">
          <input
            className="input"
            name="name"
            type="text"
            value={selectedColor}
            onChange={handleColorChange}
          />
          <span
            className="icon is-small is-left"
            style={{
              color: selectedColor,
            }}
          >
            <i className="fas fa-circle"></i>
          </span>
        </div>
        <p className="help">Only hexadecimal colors allowed</p>
      </div>

      <ColorPicker color={selectedColor} setColor={setSelectedColor} />

      <div className="field">
        <label className="label">Priority</label>
        <input
          className="input"
          name="name"
          type="number"
          value={selectedPriority}
          onChange={handlePriorityChange}
        />
      </div>

      <Button className="is-pulled-right" type="text" onClick={submitForm}>
        Save Changes
      </Button>
    </div>
  );
};

LabelsTableRowForm.propTypes = {
  label: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    color: PropTypes.string,
    priority: PropTypes.number,
  }),
  priorities: PropTypes.arrayOf(PropTypes.number),
  onSubmitForm: PropTypes.func,
};

export default LabelsTableRowForm;
